import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import css from './TipoPruebaSelector.module.css'

const TIPOS_PRUEBA = [
  { value: 'AGM', label: 'AGM' },
  { value: 'AGS', label: 'AGS' },
  { value: 'PAU', label: 'PAU' },
  { value: 'PCE', label: 'PCE' },
  { value: 'PRUEBAS_LIBRES_ESO', label: 'Pruebas Libres ESO' },
  { value: 'MAYORES_DE_25', label: 'Mayores de 25' },
  { value: 'IDIOMAS', label: 'Idiomas' }
]

const TipoPruebaSelector = ({ className, name, label, value, onChange }) => (
  <FormControl
    className={`${className} ${css.main}`}
    variant='standard'
    margin='dense'
    fullWidth
  >
    <InputLabel id={name}>{label}</InputLabel>
    <Select
      name={name}
      labelId={name}
      id={name}
      value={value}
      onChange={onChange}
      label={label}
    >
      {TIPOS_PRUEBA.map(tipo => (
        <MenuItem key={tipo.value} value={tipo.value}>
          {tipo.label}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
)

export default TipoPruebaSelector
